import React, { Component } from 'react'

class Menu extends Component {

  render() {
    const { language, t } = this.props
    return <div className="menu">
            <ul>
              <li><button className="text-hover text-hover-underline-opening" onClick={() => this.props.showText(1)}>{t(language, 'aboutHateSpeech')}</button></li>
              <li><button className="text-hover text-hover-underline-opening" onClick={() => this.props.showText(5)}>{t(language, 'aboutHateCrimes')}</button></li>
              <li><button className="text-hover text-hover-underline-opening" onClick={() => this.props.showText(2)}>{t(language, 'howToReport')}</button></li>
              <li><button className="text-hover text-hover-underline-opening" onClick={() => this.props.showText(3)}>{t(language, 'faq')}</button></li>
              <li><button className="text-hover text-hover-underline-opening" onClick={() => this.props.showText(4)}>{t(language, 'about')}</button></li>
            </ul>
          </div>
  }
}

export default Menu;
